// @flow
/*
 *  Copyright 2017 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */

import platform from 'platform';

class DeviceDetectionUtil {
    isWin() {
        if (platform && platform.os && platform.os.family) {
            return platform.os.family.toLowerCase().includes('windows');
        }
        return navigator.appVersion.indexOf('Win') !== -1;
    }

    isLinux() {
        if (platform && platform.os && platform.os.family) {
            return platform.os.family.toLowerCase() === 'linux' || platform.os.family.toLowerCase() === 'ubuntu';
        }
        return false;
    }

    /**
	 * returns true if device is Chrome OS based. Eg: a chromebook
	 *
	 * @returns true or false
	 */
    isChromeOS() {
        return navigator.userAgent.indexOf('CrOS') !== -1;
    }

    isSafari() {
        if (platform && platform.name) {
            return platform.name.toLowerCase().includes('safari');
        }
        return false;
    }

    isFirefox() {
        if (platform && platform.name) {
            return platform.name.toLowerCase().includes('firefox');
        }
        return false;
    }

    isIE() {
        if (platform && platform.name) {
            return platform.name.toLowerCase().includes('ie');
        }
        return false;
    }

    isEdge() {
        if (platform && platform.name) {
            return platform.name.toLowerCase().includes('edge') || navigator.userAgent.search(/\bedg\//i) !== -1;
        }
        return false;
    }

    isChrome() {
        if (platform && platform.name) {
            return platform.name.toLowerCase().includes('chrome') && !(navigator.userAgent.search(/\bedg\//i) !== -1);
        }
        return false;
    }

    isEdgeBeta() {
        if (platform && platform.name) {
            return platform.name.toLowerCase().includes('chrome') && (navigator.userAgent.search(/\bedg\//i) !== -1);
        }
        return false;
    }

    isInternetExplorer() {
        if (platform && platform.name) {
            return platform.name.toLowerCase().includes('ie');
        }
        return false;
    }

    isIPad() {
        if (platform && platform.os && platform.os.family && platform.os.family.toLowerCase() === 'ios'
			&& platform.product && platform.product.toLowerCase() === 'ipad') {
            return true;
        }
        // detect iPad when default desktop setting is on
        return (this.isMacOS()
			&& this.isSafari()
			&& !this.isIPhone()
			&& this.isTouchDevice());
    }

    isIPhone() {
        return platform && platform.os && platform.os.family && platform.os.family.toLowerCase() === 'ios'
			&& platform.product && platform.product.toLowerCase() === 'iphone';
    }

    isAndroid() {
        return platform && platform.os && platform.os.family && platform.os.family.toLowerCase() === 'android';
    }

    isMacOS() {
        if (platform && platform.os && platform.os.family) {
            return platform.os.family.toLowerCase().includes('os x');
        }
        if (navigator.userAgent.toLowerCase().match('mac os x')) {
            return true;
        }
        return false;
    }
}

export default new DeviceDetectionUtil();
